import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout/Layout";
import { SearchIcon, QuestionMarkCircleIcon } from "@heroicons/react/solid";
import {
  DocumentDownloadIcon,
  MailOpenIcon,
  EyeIcon,
} from "@heroicons/react/outline";
import WithdrawalServices from "../../services/WithdrawalServices";
import { Link } from "react-router-dom";
import Paginate from "../../utils/Paginate";
import { FormatMoney } from "./../../utils/formatMoney";
import { formatDate, convert, DisplayTime } from "./../../utils/convertDate";
import DatePicker from "react-date-picker";

const statusStyles = {
  Approved: "bg-green-100 text-green-800",
  Primary_Approved: "bg-blue-100 text-blue-800",
  Initiated: "bg-yellow-100 text-yellow-800",
  Pending: "bg-orange-100 text-orange-800",
  Rejected: "bg-red-100 text-red-800",
  Expired: "bg-gray-100 text-gray-800",
  Successful: "bg-green-100 text-green-800",
  TimedOut: "bg-red-100 text-red-800",
};

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
export default function CashPickUp() {
  const [search, setSearch] = useState("");
  const [pickUp, setPickUp] = useState([]);
  const [pageIndex, setPageIndex] = useState(1);
  const [prevPage, setPrev] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPage, setPage] = useState(0);
  const [nextPage, setNextPage] = useState(false);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [status, setStatus] = useState("");
  const [type, setType] = useState("");
  const [pageLength, setPageLength] = useState("");
  const oldFrom = new Date().setDate(new Date().getDate() - 7);
  const [formValues, setFormValues] = useState({
    from: new Date(oldFrom),
    to: new Date(),
  });
  const defaultTo = formatDate(new Date());
  const longNew = formatDate(defaultTo);
  const [too, setToo] = useState(convert(longNew));
  const defaultFrom = formatDate(new Date().setDate(new Date().getDate() - 7));
  const longDate = formatDate(defaultFrom);
  const [fromm, setFromm] = useState(convert(longDate));
  const [summ, setSummary] = useState({});

  const listPickUp = async () => {
    const pickUp = await WithdrawalServices.listCashPickUps(
      pageIndex,
      10,
      search,
      fromm,
      too,
      status,
      type
    );
    if (pickUp) {
      setPickUp([...pickUp.data.result]);
      setPageLength([...pickUp.data.result].length);
      setPageNumber(pickUp.data.totalCount);
      setPageIndex(pickUp.data.pageIndex);
      setPrev(pickUp.data.hasPreviousPage);
      setPage(pickUp.data.totalPages);
      setNextPage(pickUp.data.hasNextPage);
    }
    const resp = await WithdrawalServices.summary();
    setSummary(resp.data);
  };
  const handleStatus = async (text) => {
    if (text === "All") {
      const pickUp = await WithdrawalServices.listCashPickUps(
        pageIndex,
        10,
        search,
        fromm,
        too,
        status,
        type
      );
      if (pickUp) {
        setPickUp([...pickUp.data.result]);
        setPageLength([...pickUp.data.result].length);
        setPageNumber(pickUp.data.totalCount);
        setPageIndex(pickUp.data.pageIndex);
        setPrev(pickUp.data.hasPreviousPage);
        setPage(pickUp.data.totalPages);
        setNextPage(pickUp.data.hasNextPage);
      }
    } else {
      setStatus(text);
      const pickUp = await WithdrawalServices.listCashPickUps(
        pageIndex,
        10,
        search,
        fromm,
        too,
        text,
        type
      );
      if (pickUp) {
        setPickUp([...pickUp.data.result]);
        setPageLength([...pickUp.data.result].length);
        setPageNumber(pickUp.data.totalCount);
        setPageIndex(pickUp.data.pageIndex);
        setPrev(pickUp.data.hasPreviousPage);
        setPage(pickUp.data.totalPages);
        setNextPage(pickUp.data.hasNextPage);
      }
    }
  };
  const handleTypes = async (types) => {
    if (types === "All") {
      const pickUp = await WithdrawalServices.listCashPickUps(
        pageIndex,
        10,
        search,
        fromm,
        too,
        status,
        type
      );
      if (pickUp) {
        setPickUp([...pickUp.data.result]);
        setPageLength([...pickUp.data.result].length);
        setPageNumber(pickUp.data.totalCount);
        setPageIndex(pickUp.data.pageIndex);
        setPrev(pickUp.data.hasPreviousPage);
        setPage(pickUp.data.totalPages);
        setNextPage(pickUp.data.hasNextPage);
      }
    }
    setType(types);
    const pickUp = await WithdrawalServices.listCashPickUps(
      pageIndex,
      10,
      search,
      fromm,
      too,
      status,
      types
    );
    if (pickUp) {
      setPickUp([...pickUp.data.result]);
      setPageLength([...pickUp.data.result].length);
      setPageNumber(pickUp.data.totalCount);
      setPageIndex(pickUp.data.pageIndex);
      setPrev(pickUp.data.hasPreviousPage);
      setPage(pickUp.data.totalPages);
      setNextPage(pickUp.data.hasNextPage);
    }
  };

  const range = async (e) => {
    e.preventDefault();
    const newDate = formatDate(formValues.from);
    setFrom(formValues.from);
    var longDate = formatDate(newDate);
    setFromm(convert(longDate));

    const toDate = formatDate(formValues.to);
    setTo(formValues.to);
    setToo(convert(toDate));

    const pickUp = await WithdrawalServices.listCashPickUps(
      pageIndex,
      10,
      search,
      convert(newDate),
      convert(toDate),
      status,
      type
    );
    if (pickUp) {
      setPickUp([...pickUp.data.result]);
      setPageLength([...pickUp.data.result].length);
      setPageNumber(pickUp.data.totalCount);
      setPageIndex(pickUp.data.pageIndex);
      setPrev(pickUp.data.hasPreviousPage);
      setPage(pickUp.data.totalPages);
      setNextPage(pickUp.data.hasNextPage);
    }
  };
  const dateValidation = {
    fromHandler: (event) => {
      setFormValues({ ...formValues, from: event });
    },
    toHandler: (event) => {
      setFormValues({ ...formValues, to: event });
    },
  };
  const searchUp = async (text) => {
    setSearch(text);
  };
  const exportCSV = async () => {
    const resp = await WithdrawalServices.exportPickups(
      search,
      fromm,
      too,
      status,
      type
    );
    window.open(resp.data);
  };
  useEffect(() => {
    listPickUp();
  }, [pageIndex]);
  return (
    <>
      <Layout
        title={"Cash Pickup"}
        current={"/withdrawal/pickup"}
        pageTag={"withdrawal"}
      >
        <React.Fragment>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
            <dl className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 mb-5">
              <div className="relative flex bg-white pt-5 px-4 pb-5 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
                <div className="absolute  rounded-md p-3">
                  <MailOpenIcon
                    className="h-6 w-6 text-gray-900"
                    aria-hidden="true"
                  />
                </div>
                <div>
                  <p className="ml-12 text-sm font-medium text-gray-500 truncate">
                    Total CashPickup
                  </p>
                  <p className="text-2xl ml-12 font-semibold text-gray-900">
                    {summ.totalCashPickup}
                  </p>
                </div>
              </div>
              <div className="relative flex bg-white pt-5 px-4 pb-5 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
                <div className="absolute  rounded-md p-3">
                  <MailOpenIcon
                    className="h-6 w-6 text-gray-900"
                    aria-hidden="true"
                  />
                </div>
                <div>
                  <p className="ml-12 text-sm font-medium text-gray-500 truncate">
                    Total Approved{" "}
                  </p>
                  <p className="text-2xl ml-12 font-semibold text-gray-900">
                    {summ.totalApprovedCashPickup}
                  </p>
                </div>
              </div>
              <div className="relative flex bg-white pt-5 px-4 pb-5 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
                <div className="absolute  rounded-md p-3">
                  <MailOpenIcon
                    className="h-6 w-6 text-gray-900"
                    aria-hidden="true"
                  />
                </div>
                <div>
                  <p className="ml-12 text-sm font-medium text-gray-500 truncate">
                    Total Rejected{" "}
                  </p>
                  <p className="text-2xl ml-12 font-semibold text-gray-900">
                    {summ.totalRejectedCashPickup}
                  </p>
                </div>
              </div>
              <div className="relative flex bg-white pt-5 px-4 pb-5 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
                <div className="absolute  rounded-md p-3">
                  <MailOpenIcon
                    className="h-6 w-6 text-green-900"
                    aria-hidden="true"
                  />
                </div>
                <div>
                  <p className="ml-12 text-sm font-medium text-gray-500 truncate">
                    Total Pending{" "}
                  </p>
                  <p className="text-2xl ml-12 font-semibold text-green-900">
                    {summ.totalPendingCashPickup}
                  </p>
                </div>
              </div>
            </dl>
            <div className="mt-4 sm:mt-0 sm:ml-6  flex justify-end">
              <button
                type="button"
                onClick={exportCSV}
                className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-2 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
              >
                <DocumentDownloadIcon className="w-4 mr-1.5" />
                Export CSV
              </button>
            </div>
            <div className="sm:flex sm:items-center mt-10">
              <div className="sm:flex-auto flex">
                <div className="relative rounded-md shadow-sm ml-3">
                  <p className="text-sm leading-3 text-gray-500">From</p>
                  <div>
                    <DatePicker
                      onChange={dateValidation.fromHandler}
                      value={formValues.from}
                    />
                  </div>
                </div>
                <div className=" relative rounded-md shadow-sm ml-3">
                  <p className="text-sm leading-3 text-gray-500">To</p>
                  <div>
                    <DatePicker
                      onChange={dateValidation.toHandler}
                      value={formValues.to}
                    />
                  </div>
                </div>
                <div className="flex ml-3">
                  <div className="mt-5 relative rounded-md shadow-sm">
                    <div className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none">
                      <SearchIcon
                        className="h-5 w-5 text-gray-400"
                        aria-hidden="true"
                      />
                    </div>
                    <input
                      type="text"
                      name="user"
                      id="user"
                      onClick={(e) => searchUp(e.target.value)}
                      className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                      placeholder="Search withdrawal"
                    />
                    <div className=" absolute inset-y-0 right-0 flex items-center pr-3">
                      <div className="tooltip">
                        <QuestionMarkCircleIcon className="w-4 mr-1.5 text-gray-400" />
                        <span className="tooltiptext">
                          {" "}
                          <p>
                            Search by authorization code, email address and
                            first name{" "}
                          </p>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                 <div className="mt-5 relative rounded-md shadow-sm ml-3">
                  <select
                    id="currency"
                    name="currency"
                    onChange={(e) => handleStatus(e.target.value)}
                    placeholder="Sort by"
                    className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                  >
                    <option value={"All"}>Sort by</option>
                    <option value={"All"}>All</option>
                    <option value={"Pending"}>Pending</option>
                    <option value={"Approved"}>Approved</option>
                    <option value={"Rejected"}>Rejected</option>
                    <option value={"Expired"}>Expired</option>
                  </select>
                </div>
                <div className="mt-5 relative rounded-md shadow-sm ml-3">
                  <select
                    id="currency"
                    name="currency"
                    onChange={(e) => handleTypes(e.target.value)}
                    placeholder="Filter by"
                    className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                  >
                    <option value={"All"}>Filter by</option>
                    <option value={"All"}>All</option>
                    <option value={"Self"}>Self</option>
                    <option value={"Thirdparty"}>Third party</option>
                  </select>
                </div>
                <div className="mt-5 ml-4">
                  <button
                    onClick={range}
                    className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                  >
                    Search
                  </button>
                </div>
               
              </div>
            </div>
            {pickUp.length === 0 ? (
              <div className=" mt-8">
                {" "}
                No data available for these dates to show.{" "}
              </div>
            ) : (
              <>
                <div className="mt-4 flex flex-col">
                  <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                      <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg">
                        <table className="min-w-full table-fixed divide-y divide-gray-300">
                          <thead>
                            <tr>
                              <th
                                scope="col"
                                className="pl-3 min-w-[8rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-400"
                              >
                                Sender's Name
                              </th>
                              <th
                                scope="col"
                                className="min-w-[10rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-400 "
                              >
                                Cash Pickup Type
                              </th>
                              <th
                                scope="col"
                                className=" min-w-[10rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                              >
                                Account Number
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                              >
                                Branch
                              </th>
                              <th
                                scope="col"
                                className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                              >
                                Transaction Date
                              </th>
                              <th
                                scope="col"
                                className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                              >
                                Time Created
                              </th>
                              <th
                                scope="col"
                                className="px-3 min-w-[12rem]  py-3.5 text-left text-sm italic font-normal text-gray-400"
                              >
                                Third Party Phone Number
                              </th>
                              <th
                                scope="col"
                                className="px-3 min-w-[8rem]  py-3.5 text-left text-sm italic font-normal text-gray-400"
                              >
                                Verification Type
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 min-w-[10rem]  text-left text-sm italic font-normal text-gray-400"
                              >
                                Beneficiary’s Name
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                              >
                                Status
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                              >
                                Amount
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                              >
                                Date Modified
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                              >
                                Time Modified
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                              >
                                Modified By
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                              ></th>

                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                              >
                                <span className="sr-only">Edit</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-gray-200 bg-white">
                            {pickUp.map((person, i) => (
                              <tr key={i} className="bg-gray-50">
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                  {person.senderName}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                  {person.cashPickupType}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                  {person.accountNumber}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                  {person.branchName}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                  {formatDate(person.dateCreated)}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                  {DisplayTime(person.dateCreated)}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                  {person.thirdpartyPhoneNumber}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                  {person.thirdpartyVerificationType}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  {person.thirdpartyName}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  <span
                                    className={classNames(
                                      statusStyles[person.cashPickupStatus] ||
                                        "bg-gray-100 text-gray-800",
                                      "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium capitalize"
                                    )}
                                  >
                                    {person.cashPickupStatus}
                                  </span>
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  {FormatMoney(person.amount)}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  {formatDate(person.dateModified)}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  {DisplayTime(person.dateModified)}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  {person.modifiedBy}
                                </td>
                                <td>
                                  <Link
                                    to={`/pickup/view?code=${person.authorizationCode}`}
                                    className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-full shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
                                  >
                                    <EyeIcon className="w-4 h-4 mr-1" />
                                    View
                                  </Link>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <Paginate
                  nextPage={nextPage}
                  pageIndex={pageIndex}
                  totalCount={pageNumber}
                  totalPages={totalPage}
                  prevPage={prevPage}
                  setPageIndex={setPageIndex}
                />
              </>
            )}
          </div>
        </React.Fragment>
      </Layout>
    </>
  );
}
